import React, { useEffect, useState } from 'react';

type Props = {
    enabled: boolean;
    apiKey: string | null;
};

export const LiveChat: React.FC<Props> = (props) => {
    const [src, setSrc] = useState<string | null>(null);
    const { apiKey } = props;
    useEffect(() => {
        (window as any).__lc = (window as any).__lc || {};
        (window as any).__lc.license = apiKey;
        setSrc(`https://cdn.livechatinc.com/tracking.js`);
    }, [apiKey]);
    useEffect(() => {
        if (!src) return;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.async = true;
        document.head.appendChild(script);
        return () => script.remove();
    }, [src]);
    return null;
};
